export const short = (text: string, length = 7) => text.length > length * 2 + 3 ? `${text.slice(0, length)}…${text.slice(-length)}` : text;
export const compact = (value: number, digits = 2) => new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: digits }).format(value);
export function usd(value: number | null | undefined, price = false): string {
  if (value == null || !Number.isFinite(value)) return '—';
  if (price && value > 0 && value < 0.01) return '$' + value.toLocaleString('en-US', { maximumSignificantDigits: 5 });
  if (!price && Math.abs(value) >= 10_000) return '$' + compact(value);
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: price ? 6 : 2 });
}
export function amount(value: bigint, decimals = 8, digits = 4) {
  const sign = value < 0n ? '-' : '';
  const positive = value < 0n ? -value : value;
  const scale = 10n ** BigInt(decimals);
  const fraction = (positive % scale).toString().padStart(decimals, '0').slice(0, digits).replace(/0+$/, '');
  return sign + (positive / scale).toLocaleString('en-US') + (fraction ? '.' + fraction : '');
}
export function age(ns: bigint, now = Date.now()) {
  if (ns === 0n) return '—';
  const elapsed = Math.max(0, (now - Number(ns / 1_000_000n)) / 1000);
  if (elapsed < 60) return `${Math.floor(elapsed)}s`;
  if (elapsed < 3600) return `${Math.floor(elapsed / 60)}m`;
  if (elapsed < 86400) return `${Math.floor(elapsed / 3600)}h`;
  return `${Math.floor(elapsed / 86400)}d`;
}
export const timestamp = (ns: bigint) => new Date(Number(ns / 1_000_000n)).toLocaleString();
export function safeUrl(value?: string): string | undefined {
  if (!value) return undefined;
  try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined; } catch { return undefined; }
}
export function downloadCsv(filename: string, headers: string[], rows: (string | number)[][]) {
  const cell = (value: string | number) => '"' + String(value).replace(/^[=+@-]/, "'$&").replaceAll('"', '""') + '"';
  const csv = [headers, ...rows].map(row => row.map(cell).join(',')).join('\r\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  const anchor = document.createElement('a'); anchor.href = url; anchor.download = filename; anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
